var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 4.66507L16.0577 12.4426L20.3327 20.6251H3.6677L7.94269 12.4426L12.0002 4.66507ZM12.0002 0.945068L6.41269 11.6476L0.825195 22.3501H23.1752L17.5877 11.6476L12.0002 0.945068ZM12.0002 16.7701C12.5852 16.7701 13.0277 17.2201 13.0277 17.7976C13.0277 18.3751 12.5852 18.8251 12.0002 18.8251C11.4152 18.8251 10.9727 18.3751 10.9727 17.7976C10.9727 17.2201 11.4152 16.7701 12.0002 16.7701ZM12.7652 9.59257L12.5777 15.7426H11.4002L11.2277 9.59257H12.7652Z",
    fill: "#2A2859"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning-triangle.ee076044.svg";
export { ForwardRef as ReactComponent };